import N3 from "./libs/n3/n3.min";

const getCssStyle = ( element, prop ) => {
  return window.getComputedStyle( element, null ).getPropertyValue( prop );
};

const getElFont = ( el = document.body ) => {
  const weight = getCssStyle( el, "font-weight" ) || "normal";
  const size = getCssStyle( el, "font-size" ) || "16px";
  const family = getCssStyle( el, "font-family" ) || "Times New Roman";

  return {
    weight,
    size,
    family
  };
}

const measureText = ( text, el ) => {
  let d = document.createElement( "div" );

  document.body.appendChild( d );
  const font = getElFont( el );

  d.style.display = "inline-block";
  d.style.whiteSpace = "pre";
  d.style.position = "absolute";
  d.style.left = -1000 + "px";
  d.style.top = -1000 + "px";
  d.style.fontFamily = font.family;
  d.style.fontSize = font.size;
  d.style.fontWeight = font.weight;

  d.textContent = text;

  const r = {
    w: d.clientWidth,
    h: d.clientHeight
  };

  document.body.removeChild( d );
  d = null;

  return r;
}

const neighboursGet = ( id, graph ) => {
  for ( const ido in graph ) {
    if ( graph.hasOwnProperty( ido ) ) {
      const o = graph[ ido ];
    }
  }
};

const ttlParse = async ttlData => {
  const graph = {};
  const graphPrefixes = {};

//console.log( ttlData );

  const parser = new N3.Parser( { format: "application/trig" } );
  await parser.parse(
    ttlData,
    ( error, quad, prefixes ) => {
      if ( error ) console.error( "N3 TTL PARSE ERROR: " + error );

      if ( quad ) {
        const f = quad._subject.id;
        const l = quad._predicate.id;
        const t = quad._object.id;

        switch ( l ) {
          case "rdfs:label":
          case "http://www.w3.org/2000/01/rdf-schema#label":
            if ( !( f in graph ) ) graph[ f ] = { id: f, types: {}, name: null, links: [] };
            graph[ f ].name = ( "" + t ).replace( /^"(.*?)"$/, "$1" );
          break;

          case "rdf:type":
          case "http://www.w3.org/1999/02/22-rdf-syntax-ns#type":
            if ( !( f in graph ) ) graph[ f ] = { id: f, types: {}, name: null, links: [] };
            graph[ f ].types[ t ] = t;
          break;

          default:
            if ( !(f in graph) ) graph[ f ] = { id: f, types: {}, name: null, links: [] };
            if ( !(t in graph) ) graph[ t ] = { id: t, types: {}, name: null, links: [] };
            if ( !(l in graph) ) graph[ l ] = { id: l, types: {}, name: null, links: [] };

            graph[ l ].isLink = true;

            graph[ f ].links.push( { id: t, refId: l, fwd: true } );
            graph[ t ].links.push( { id: f, relId: l, fwd: false } );
        }
      }
      else {
        Object.assign( graphPrefixes, prefixes );
      }
    }
  );

  for ( const id in graph ) {
    if ( graph.hasOwnProperty( id ) ) {
      const o = graph[ id ];
      for ( const idt in o.types ) {
        if ( o.types.hasOwnProperty( idt ) && ( idt in graph ) && graph[ idt ].name ) o.types[ idt ] = graph[ idt ].name;
      }
    }
  }

//console.log( "GRAPH", JSON.stringify( graph, null, "\t" ) );

  return {
    graph:    graph,
    prefixes: graphPrefixes
  };
};


const graphGetNameById = ( graph, prefixes, id ) => {
  if ( id in graph && graph[ id ].name ) return graph[ id ].name;

  for ( const pid in prefixes ) {
    if ( prefixes.hasOwnProperty( pid ) ) {
      const v = prefixes[ pid ];

      if ( id.indexOf( v ) === 0 ) return id.substr( v.length );
    }
  }

  return id;
};

/*
const attachFromAngle = angle => {
  if ( angle > 45 && angle <= 135 ) return "right";
  if ( angle > 135 && angle <= 225 ) return "bottom";
  if ( angle > 225 && angle <= 315 ) return "left";
  return "top";
};

const angleBwPoints = ( p1, p2 ) => {
  const angle = Math.atan2( p2.y - p1.y, p2.x - p1.x ) * 180 / Math.PI;
  return angle < 0 ? 360 + angle : angle;
}

function cang( x, y, cx, cy ) {
	x = cx - x;
  y = cy - y;

  let a = Math.atan2( x, y );
  a = ( a > 0 ? a : ( 2 * Math.PI + a ) ) * 360 / ( 2 * Math.PI )

	return a;
}
*/

const sides = [ undefined, "top", "right", "bottom", "left" ];
const sidesCaches = new Map();
const sideGetCords = ( side, x, y, w, h ) => {
    const k = `${x}|${y}|${w}|${h}`;
    if ( sidesCaches.has( k ) ) return sidesCaches.get( k );

    switch ( side ) {
      //top
      case 1:
        x += w / 2;
      break;

      //right
      case 2:
        x += w;
        y += h / 2;
      break;

      //bottom
      case 3:
        x += w / 2;
        y += h;
      break;

      //left
      case 4:
        y += h / 2;
      break;
    }

    const r = { x, y };
    sidesCaches[ k ] = r;
    return r;
}

const measureO = ( id, graph, prefixes ) => {
  const b = 15; //border

  if ( id in graph ) {
    const o = graph[ id ];

    if ( !( "name" in o ) || !( "w" in o ) || !( "h" in o ) ) {
      let title = graphGetNameById( graph, prefixes, id );
      const types = Object.values( o.types ).join( ", " );
      if ( types ) title += "\n\n" + types;

      const titleSize = measureText( title );
      o.w = titleSize.w + b + b;
      o.h = titleSize.h + b + b;
      o.name = title;
    }
  }
};

const neighboursToDiagram = ( id, graph, prefixes, dg, arc, centerX, centerY ) => {
  const ido = graph[ id ];

  //put main object to the idx/idy
  if ( !( "dgN" in ido ) ) {
    measureO( id, graph, prefixes ); //measure main object if not

    ido.x = centerX;
    ido.y = centerY;

    let x = centerX - ido.w / 2;
    let y = centerY - ido.h / 2

    ido.dgN = dg.s.length;
    dg.s.push(
      {
        type: 2,
        position: { x, y },
        title: ido.name,
        x,
        y,
        w: ido.w,
        h: ido.h
      }
    );
  }

  //counts neighbours
  let objectsTotal = new Set();
  let sizeMax = 0;
  for ( const l of ido.links ) {
    const lid  = l.id;

    if ( lid in graph ) {
      const o = graph[ lid ];

      if ( !( "dgN" in o ) ) {
        measureO( lid, graph, prefixes );

        if ( o.w > sizeMax ) sizeMax = o.w;
        if ( o.h > sizeMax ) sizeMax = o.h;

        objectsTotal.add( lid );
      }
    }
  }
  objectsTotal = objectsTotal.size;

  //put all linked objects to the diagram
  let r = Math.max( ido.w, ido.h ) + 200, a, as;
  if ( arc ) {
    const sector = 140;
    as = sector / objectsTotal;

    a = ( "a" in ido ? ido.a : 0 ) - ( sector / 2 );
    if ( objectsTotal == 1 ) a += sector / 2;

    a += 30;
  }
  else {
    as = 360 / objectsTotal;

    a = 0;
  }

  for ( const l of ido.links ) {
    const lid  = l.id;

    if ( lid in graph ) {
      const o = graph[ lid ];

      //if object is not on the diagram
      if ( !( "dgN" in o ) ) {
        o.dgN = dg.s.length;

        const aRad = a * Math.PI / 180;
        let x = ido.x + r * Math.sin( aRad );
        let y = ido.y + r * Math.cos( aRad );
        o.x = x;
        o.y = y;
        o.a = a;

        x -= o.w / 2;
        y -= o.h / 2;

        dg.s.push(
          {
            type: 2,
            position: { x, y },
            title: o.name,
            x,
            y,
            w: o.w,
            h: o.h
          }
        );

        a += as;
      }
    }
  }

  for ( const l of ido.links ) {
    const lid  = l.id;

    if ( lid in graph ) {
      const o = graph[ lid ];
      if (
        !( "dgN" in o ) ||
        o.links.find(
          l => {
            return l.id in graph && !( "dgN" in graph[ l.id ] )
          }
        )
      ) {
        neighboursToDiagram( lid, graph, prefixes, dg, true, ido.x, ido.y );
      }
    }
  }

};

const JSONsave = o => {
    const a = document.createElement( "a" );
    const file = new Blob( [ JSON.stringify( o ) ], { type: "text/json" } );
    a.href = URL.createObjectURL( file );
    a.download = "file.json";
    a.click();
};

const graphToDiagram = ( graph, prefixes, centerX, centerY, ido ) => {
  if ( !centerX ) centerX = 0;
  if ( !centerY ) centerY = 0;

  const dg = {
    v: "1.1",
    s: []
  };

  //console.log( JSON.stringify( graph, null, "\t" ) );

  //remove objects without links, and some utility objects
  //also, there can exist links, which are not connected to any enumerated objects - they will be ignored next
  for ( const id in graph ) {
    if ( graph.hasOwnProperty( id ) ) {
      const o = graph[ id ];
      if (
        !o.isLink && //if it's an object
        (
          !o.links || !o.links.length ||
          id.indexOf( "http://www.w3.org/ns/shacl#" ) == 0
        )
      ) delete graph[ id ];
    }
  }

  //only if we have any data in graph
  if ( ( ido in graph ) && Object.keys( graph ).length ) {
//  JSONsave( graph, "graph.json" );
//  JSONsave( prefixes, "graph.json" );
/*
    //x=r * sinθ, y=r * cosθ

    const b = 15;
    let x = 0, y = 0;

    let objectsTotal = 0;
    let sizeMax = 0;
    for ( const id in graph ) {
      if ( graph.hasOwnProperty( id ) ) {
        const o = graph[ id ];
        if ( !o.isLink ) {
          let title = graphGetNameById( graph, prefixes, id );
          const types = Object.values( o.types ).join( ", " );
          if ( types ) title += "\n\n" + types;

          const titleSize = measureText( title );
          o.w = titleSize.w + b + b;
          o.h = titleSize.h + b + b;
          o.name = title;

          // o.w = 20;
          // o.h = 20;

          if ( id != ido ) {
            objectsTotal++;
            if ( o.w > sizeMax ) sizeMax = o.w;
            if ( o.h > sizeMax ) sizeMax = o.h;
          }
        }
      }
    }

    let r = sizeMax * 2, a = 0, as = 360 / objectsTotal;

    //put main object to center
    {
      const o = graph[ ido ];
      const x = centerX - o.w / 2;
      const y = centerY - o.h / 2
      o.dgN = dg.s.length;
      dg.s.push(
        {
          type: 2,
          position: { x, y },
          title: o.name,
          x,
          y,
          w: o.w,
          h: o.h
        }
      );
    }

    //put all objects except main to the diagram
    for ( const id in graph ) {
      if ( graph.hasOwnProperty( id ) && id != ido ) {
        const o = graph[ id ];
        if ( !o.isLink && !( "dgN" in o ) ) {
          o.dgN = dg.s.length;

          const ar = a * Math.PI / 180;
          x = centerX + r * Math.sin( ar ) - o.w / 2;
          y = centerY + r * Math.cos( ar ) - o.h / 2;
          a += as;

          dg.s.push(
            {
              type: 2,
              position: { x, y },
              title: o.name,
              x,
              y,
              w: o.w,
              h: o.h
            }
          );
        }
      }
    }
  */

    neighboursToDiagram( ido, graph, prefixes, dg, false, centerX, centerY );

    //put links
    sidesCaches.clear();
    for ( const id in graph ) {
      if ( graph.hasOwnProperty( id ) ) {
        const o = graph[ id ];
        if ( o.isLink || !( "dgN" in o ) ) continue;

        const p1 = dg.s[ o.dgN ];
        p1.x += o.w / 2;
        p1.y += o.h / 2;

        if ( "dgN" in o ) {
          for ( const l of o.links ) {
            //only forwards link, cause backwards came from linked objects
            if ( !l.fwd ) continue;

            const lo = graph.hasOwnProperty( l.id ) && ( "dgN" in graph[ l.id ] ) ? graph[ l.id ] : null;
            if ( !lo ) continue;

            const p2 = dg.s[ lo.dgN ];
  /*
            p2.x += lo.w / 2;
            p2.y += lo.h / 2;

            const p2angle = angleBwPoints( p1, p2 );
            const p1angle = 180 - p2angle; //Math.atan2( oDgP.y - tDgP.y, oDgP.x - tDgP.x ) * 180 / Math.PI;
            const p1attach = attachFromAngle( p1angle );
            const p2attach = attachFromAngle( p2angle );
  */
            //find minimum length between all sides of two objects
            let p1SideMin = 1, p2SideMin = 1;
            let p1p2Len = Infinity;

            for ( let p1Side = 1; p1Side <= 4; p1Side++ ) {
              const p1SideCords = sideGetCords( p1Side, p1.x, p1.y, o.w, o.h );

              for ( let p2Side = 1; p2Side <= 4; p2Side++ ) {
                const p2SideCords = sideGetCords( p2Side, p2.x, p2.y, lo.w, lo.h );

                let len;
                const k = `len|${p1SideCords.x}|${p1SideCords.y}|${p2SideCords.x}|${p2SideCords.y}`;
                if ( sidesCaches.has( k ) ) len = sidesCaches.get( k );
                else {
                  len = Math.sqrt( Math.pow( p2SideCords.x - p1SideCords.x, 2 ) +  Math.pow( p2SideCords.y - p1SideCords.y, 2 ) );
                  sidesCaches.set( k, len );
                }
                if ( p1p2Len === null || len < p1p2Len ) {
                  p1p2Len = len;
                  p1SideMin = p1Side;
                  p2SideMin = p2Side;
                }
              }
            }

            dg.s.push(
              {
                type: 0,
                e: {
                  s: o.dgN,
                  k: sides[ p1SideMin ] //p1attach
                },
                s: {
                  s: lo.dgN,
                  k: sides[ p2SideMin ] //p2attach
                },
                title: graphGetNameById( graph, prefixes, l.refId ),
                c: [
                  "arw-s", //arw-e
                  ...l.fwd ? [] : [ "dash" ]
                ]
              }
            );
          }
        }
      }
    }
  }

  return dg;
};

export async function ttlToDiagram( data, centerX, centerY, id ) {
  try {
    const { graph, prefixes } = await ttlParse( data );

    for ( const pidShort in prefixes ) {
      if ( prefixes.hasOwnProperty( pidShort ) ) {
        const ido = prefixes[ pidShort ] + id;
        if ( ido in graph ) {
          id = ido;
          break;
        }
      }
    }

    const dg = graphToDiagram( graph, prefixes, centerX, centerY, id );
    if ( dg ) return dg;
  }
  catch ( e ) {
    console.error( e );
  }

  return {
    v: "1.1",
    s: []
  };
}
